function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { bool, node, shape, string, oneOfType, number, array, func } from "prop-types";
import { components } from "react-select";
import classNamesMaker from "classnames";
import { Text, TEXT_COLORS, TEXT_TYPES } from "#library/components/Text/Text";
import { DATA_SPACER } from "#library/constants/enums";
import { TickBox } from "#library/components/Checkbox/TickBox";
import styles from "./option.module.css";
export var OptionCheckbox = function OptionCheckbox(props) {
  var children = props.children,
    _props$isSelected = props.isSelected,
    isSelected = _props$isSelected === void 0 ? false : _props$isSelected,
    _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    _props$isIndeterminat = props.isIndeterminate,
    isIndeterminate = _props$isIndeterminat === void 0 ? false : _props$isIndeterminat,
    _props$isHeadingOptio = props.isHeadingOption,
    isHeadingOption = _props$isHeadingOptio === void 0 ? false : _props$isHeadingOptio,
    _props$data = props.data,
    count = _props$data.count,
    indeterminate = _props$data.indeterminate,
    isCheckbox = props.selectProps.isCheckbox,
    innerProps = props.innerProps;
  var _ref = innerProps || {},
    onClick = _ref.onClick;
  var countDisplayable = count === null || count === void 0 ? void 0 : count.toString();
  var _useState = useState(indeterminate && !isSelected),
    _useState2 = _slicedToArray(_useState, 2),
    indeterminateForDisplayOnly = _useState2[0],
    setIndeterminateForDisplayOnly = _useState2[1];
  useEffect(function () {
    if (isSelected) {
      setIndeterminateForDisplayOnly(false);
    }
  }, [isSelected]);
  var wrapperClassNames = classNamesMaker(styles["jds-Option__wrapper"], _defineProperty({}, styles["jds-Option__wrapper--grouped"], isCheckbox && isHeadingOption));
  var customOnClick = function customOnClick(event) {
    setIndeterminateForDisplayOnly(false);
    if (onClick) {
      onClick(event);
    }
  };
  var enhanceInnerProps = _objectSpread(_objectSpread({}, innerProps), {}, {
    onClick: customOnClick
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles["jds-Option__outer"]
  }, /*#__PURE__*/React.createElement(components.Option, _extends({}, props, {
    innerProps: _objectSpread({}, enhanceInnerProps)
  }), /*#__PURE__*/React.createElement("div", {
    className: wrapperClassNames
  }, /*#__PURE__*/React.createElement(TickBox, {
    hasLabel: false,
    isChecked: isSelected,
    isIndeterminate: isIndeterminate || indeterminateForDisplayOnly,
    "data-spacer": DATA_SPACER.RIGHT_100,
    className: styles["jds-Option__TickBox"]
  }), /*#__PURE__*/React.createElement("div", {
    className: styles["jds-Option"]
  }, children, countDisplayable && /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    color: isDisabled ? TEXT_COLORS.GREY_LIGHT : TEXT_COLORS.GREY,
    type: TEXT_TYPES.SMALL,
    dataSpacer: DATA_SPACER.LEFT_100
  }, "(", countDisplayable, ")")))));
};
OptionCheckbox.propTypes = {
  children: node.isRequired,
  isSelected: bool,
  isDisabled: bool,
  isIndeterminate: bool,
  isHeadingOption: bool,
  data: oneOfType([shape({
    count: oneOfType([string, number])
  }), array]).isRequired,
  selectProps: shape({
    isCheckbox: bool
  }).isRequired,
  innerProps: shape({
    onClick: func
  })
};